import { TRemoteDeploymentStore } from '@monorepo/types';
import { RemoteDeploymentStoreActionTypes, TRemoteDeploymentStoreActions } from './remote-deployment-db.actions';

export function getRemoteDeploymentStoreInitalState() {
  const remoteDeploymentStoreInitalState: TRemoteDeploymentStore = {};
  return remoteDeploymentStoreInitalState;
}
export const remoteDeploymentStoreInitalState: TRemoteDeploymentStore = getRemoteDeploymentStoreInitalState();

export function RemoteDeploymentStoreStateReducer(
  state: TRemoteDeploymentStore = remoteDeploymentStoreInitalState,
  action: TRemoteDeploymentStoreActions,
): TRemoteDeploymentStore {
  switch (action.type) {
    case RemoteDeploymentStoreActionTypes.SetRemoteDeploymentState:
    case RemoteDeploymentStoreActionTypes.UpdateRemoteDeploymentState:
      return {
        ...state,
        updatesInfo: action.remoteDeploymentDB,
      };
    case RemoteDeploymentStoreActionTypes.ClearRemoteDeploymentState:
      return {
        ...state,
        updatesInfo: undefined,
      };
    default:
      return state;
  }
}
